import React, { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/services.css";

function ServicesPage() {
  const [services, setServices] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    service_name: "",
    package_name: "",
    description: "",
    price: "",
    duration: "",
    status: "",
  });

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const res = await API.get("/services");
      setServices(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "price") value = value.replace(/\D/g, "");
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post("/services", form);
      setShow(false);
      setForm({
        service_name: "",
        package_name: "",
        description: "",
        price: "",
        duration: "",
        status: "",
      });
      fetchServices();
    } catch (err) {
      console.log(err);
    }
  };

  const packageIconMap = {
    SEO: "📈",
    "Google Ads": "🎯",
    Website: "🌐",
    "Social Media": "📱",
  };

  const packageColorMap = {
    SEO: "svc-blue",
    "Google Ads": "svc-orange",
    Website: "svc-teal",
    "Social Media": "svc-amber",
  };

  const activeCount = services.filter((s) => s.status === "active").length;
  const avgPrice =
    services.length > 0
      ? Math.round(
          services.reduce((sum, s) => sum + Number(s.price || 0), 0) /
            services.length
        )
      : 0;

  return (
    <div className="sp-page">

      {/* ── HEADER ── */}
      <div className="sp-header">
        <div className="sp-header-left">
          <div className="sp-brand">
            // {/* <div className="sp-brand-icon">DM</div>
            // <span className="sp-brand-name">DigiMark Agency</span> */}
          </div>
          <h1 className="sp-title">Services</h1>
          <p className="sp-subtitle">Manage your digital marketing offerings</p>
        </div>
        <button className="sp-add-btn" onClick={() => setShow(true)}>
          <span className="sp-add-icon">+</span> Add service
        </button>
      </div>

      {/* ── STATS ── */}
      <div className="sp-stats">
        <div className="sp-stat">
          <span className="sp-stat-label">Total services</span>
          <span className="sp-stat-value">{services.length}</span>
          <span className="sp-stat-badge badge-blue">All packages</span>
        </div>
        <div className="sp-stat">
          <span className="sp-stat-label">Active</span>
          <span className="sp-stat-value">{activeCount}</span>
          <span className="sp-stat-badge badge-green">Running now</span>
        </div>
        <div className="sp-stat">
          <span className="sp-stat-label">Avg. price</span>
          <span className="sp-stat-value">
            ₹{avgPrice.toLocaleString("en-IN")}
          </span>
          <span className="sp-stat-badge badge-orange">Per service</span>
        </div>
        <div className="sp-stat">
          <span className="sp-stat-label">Packages</span>
          <span className="sp-stat-value">
            {new Set(services.map((s) => s.package_name)).size}
          </span>
          <span className="sp-stat-badge badge-blue">Categories</span>
        </div>
      </div>

      {/* ── SERVICE CARDS ── */}
      <div className="sp-section-head">
        <h2 className="sp-section-title">All services</h2>
        <button className="sp-refresh-btn" onClick={fetchServices}>
          ↻ Refresh
        </button>
      </div>

      <div className="sp-grid">
        {services.length === 0 && (
          <div className="sp-empty">
            No services yet. Click <strong>Add service</strong> to get started.
          </div>
        )}

        {services.map((s) => (
          <div
            className={`sp-card ${packageColorMap[s.package_name] || "svc-blue"}`}
            key={s.id}
          >
            <div className="sp-card-top-bar" />
            <div className="sp-card-icon">
              {packageIconMap[s.package_name] || "⚙️"}
            </div>
            <div className="sp-card-name">{s.service_name}</div>
            <div className="sp-card-pkg">{s.package_name}</div>
            <div className="sp-card-price">₹{Number(s.price).toLocaleString("en-IN")}</div>
            <div className="sp-card-dur">⏱ {s.duration}</div>
            <div className="sp-card-footer">
              <div className={`sp-status ${s.status === "active" ? "status-active" : "status-inactive"}`}>
                <span className="sp-dot" />
                {s.status === "active" ? "Active" : "Inactive"}
              </div>
              <div className="sp-card-actions">
                <button className="sp-icon-btn" title="Edit">✏️</button>
                <button className="sp-icon-btn sp-delete-btn" title="Delete">🗑</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── MODAL ── */}
      {show && (
        <div className="sp-overlay" onClick={(e) => e.target === e.currentTarget && setShow(false)}>
          <div className="sp-modal">
            <div className="sp-modal-header">
              <h3 className="sp-modal-title">Add new service</h3>
              <button className="sp-modal-close" onClick={() => setShow(false)}>✕</button>
            </div>

            <form onSubmit={handleSubmit} className="sp-form">
              <div className="sp-form-group">
                <label className="sp-label">Service name</label>
                <input
                  className="sp-input"
                  name="service_name"
                  placeholder="e.g. On-page SEO audit"
                  value={form.service_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="sp-form-group">
                <label className="sp-label">Package</label>
                <select
                  className="sp-input"
                  name="package_name"
                  value={form.package_name}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select package</option>
                  <option value="SEO">SEO</option>
                  <option value="Google Ads">Google Ads</option>
                  <option value="Website">Website</option>
                  <option value="Social Media">Social Media</option>
                </select>
              </div>

              <div className="sp-form-group">
                <label className="sp-label">Description</label>
                <textarea
                  className="sp-input sp-textarea"
                  name="description"
                  placeholder="Brief description of the service..."
                  value={form.description}
                  onChange={handleChange}
                />
              </div>

              <div className="sp-form-row">
                <div className="sp-form-group">
                  <label className="sp-label">Price (₹)</label>
                  <input
                    className="sp-input"
                    name="price"
                    placeholder="15000"
                    value={form.price}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="sp-form-group">
                  <label className="sp-label">Duration</label>
                  <input
                    className="sp-input"
                    name="duration"
                    placeholder="3 months"
                    value={form.duration}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="sp-form-group">
                <label className="sp-label">Status</label>
                <select
                  className="sp-input"
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              <div className="sp-modal-actions">
                <button type="submit" className="sp-btn-save">Save service</button>
                <button type="button" className="sp-btn-cancel" onClick={() => setShow(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ServicesPage;